@if (props) {
  <mat-form-field>
    <mat-label>{{ props.label }}</mat-label>
    <input
      matInput
      [id]="id"
      [name]="field.name"
      [type]="props.type"
      [readonly]="props.readonly"
      [required]="props.required"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [tabIndex]="props.tabindex"
      [placeholder]="props.placeholder"
      [errorStateMatcher]="matcher"
    />
    <mat-error>
      <formly-validation-message [field]="field"></formly-validation-message>
    </mat-error>
    @if (props['prefixText']) {
      <span matTextPrefix>{{ props['prefixText'] }}</span>
    }
    @if (props['suffixText']) {
      <span matTextSuffix>{{ props['suffixText'] }}</span>
    }
  </mat-form-field>
}
